import { makeVar } from "@apollo/client"

const offlineVar = makeVar(false)

const offlineReconnectingVar = makeVar(false)

export { offlineVar, offlineReconnectingVar }
